import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

const GET_POPULAR_BRANDS = gql`
  {
    getPopularKeywordsByFilterCached {
      popularBrands {
        id
        name_kr
        name
        resizedSmallLogo
      }
    }
  }
`;

const GET_TRENDING_BRANDS = gql`
  {
    getPopularKeywordsByFilterCached {
      trendingBrands {
        id
        name_kr
        name
        resizedSmallLogo
      }
    }
  }
`;

/**
 * 브랜드 정보 가져오기
 */
export const usePopularBrands = (type = "popular") => {
  const { loading, error, data } = useQuery(
    type === "popular" ? GET_POPULAR_BRANDS : GET_TRENDING_BRANDS,
  );

  return { loading, error, data };
};
